// imports
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe, Stripe } from '@stripe/stripe-js';
import React, { FC, Fragment, useCallback, useEffect, useState } from 'react';
// components
import CardModal from './CardModal';
// interfaces
import { ChangeCardModalProps } from '../../app/interfaceTypes';

const StripeChangeCardModal: FC<ChangeCardModalProps> = ({ refetch, setCardData }) => {
  const stripePublicKey = import.meta.env.VITE_STRIPE_PUBLIC_KEY;
  const [stripe, setStripe] = useState<Stripe | null>(null);

  const loadStripeConfig = useCallback(async () => {
    const response = await loadStripe(stripePublicKey);
    if (response) {
      setStripe(response);
    }
  }, [stripePublicKey]);

  useEffect(() => {
    stripePublicKey && loadStripeConfig();
  }, [loadStripeConfig, stripePublicKey]);

  return (
    <Fragment>
      <Elements stripe={stripe}>
        <CardModal refetch={refetch} setCardData={setCardData} />
      </Elements>
    </Fragment>
  );
};

export default StripeChangeCardModal;
